import React from 'react';

const features = [
    {
        id: 1,
        title: 'Fresh Ingredients',
        description: 'We source only the freshest, highest-quality ingredients from trusted local farms and suppliers.',
        // cta: 'Read more',
        // ctaLink: '/our-story#ingredients',
        image: '/images/fresh ingrdeints.png',
    },
    {
        id: 2,
        title: 'Sustainably Sourced',
        description: 'Our milk comes from pasture-raised cows on sustainable farms committed to animal welfare.',
        // cta: 'Read more',
        // ctaLink: '/sustainability',
        image: '/images/sustainability.png',
    },
    {
        id: 3,
        title: 'No Artificial Preservatives',
        description: 'Pure, clean ingredients with no artificial colors, flavors, or preservatives. Ever.',
        // cta: 'Read more',
        // ctaLink: '/our-story#purity',
        image: '/images/no-preservatives.png',
    },
    {
        id: 4,
        title: 'Fast & Reliable Delivery',
        description: 'Fresh dairy delivered to your doorstep with temperature-controlled shipping across.',
        // cta: 'Read more',
        // ctaLink: '/delivery',
        image: '/images/delivery.png',
    }
];

const BrandValuesSection = () => {
    return (
        <section id="brand" className="relative py-20 md:py-40 lg:py-40 overflow-hidden">
            {/* Background Image - Light overlay like  */}
            <div className="absolute inset-0 w-full h-full">
                <img
                    src="/images/section1.png"
                    alt="Background"
                    className="w-full h-full object-cover"
                />
                {/* Light white overlay - EXACTLY like  */}
                <div className="absolute inset-0" />
            </div>

            {/* Content - Relative to appear above background */}
            <div className="relative z-10 max-w-7xl mx-auto px-6">
                {/* Section Header - EXACTLY like  */}
                <div className="text-center mb-12 md:mb-16">
                    <span className="text-[#DE0000] uppercase tracking-[0.2em] text-xs md:text-sm font-semibold mb-4 block">
                        OUR PROMISE
                    </span>
                    <h1 className="text-3xl text-grey md:text-4xl lg:text-5xl xl:text-6xl font-serif text-gray-900 max-w-4xl mx-auto leading-tight">
                        Frelish is Shaping the Future of Fresh Dairy
                    </h1>
                </div>

                {/* 4-Pillar Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
                    {features.map((feature, index) => (
                        <div
                            key={feature.id}
                            className="flex flex-col items-center text-center group h-full"
                        >
                            {/* Icon/Image */}
                            <div className="w-24 h-24 mb-6 flex text-grey items-center justify-center">
                                <img
                                    src={feature.image}
                                    alt={feature.title}
                                    className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
                                    loading="lazy"
                                />
                            </div>

                            {/* Title - BLACK text like  */}
                            <h3 className="text-xl text-grey md:text-1xl font-bold text-gray-900 mb-4">
                                {feature.title}
                            </h3>

                            {/* Description - GRAY text like , FIXED HEIGHT for alignment */}
                            <div className="flex-grow flex items-start justify-center w-full">
                                <p className="text-black-600 text-black text-sm md:text-base leading-relaxed max-w-xs mx-auto mb-6 min-h-[100px] md:min-h-[120px] flex items-center">
                                    {feature.description}
                                </p>
                            </div>

                            {/* CTA Button */}
                            {/*<a
                                href={feature.ctaLink}
                                className="inline-flex items-center text-grey justify-center px-6 py-3 border-2 border-white-900 text-gray-900 font-semibold text-sm rounded-full hover:bg-gray-900 hover:text-white transition-all duration-300 group/btn mt-auto"
                            >
                                <span>{feature.cta}</span>
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    className="ml-2 group-hover/btn:translate-x-1 transition-transform"
                                >
                                    <path
                                        d="M6 12L10 8L6 4"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </a>*/}
                        </div>
                    ))}
                </div>

                {/* Bottom CTA */}
                {/*<div className="text-center mt-16">
                    <a
                        href="/our-story"
                        className="inline-flex items-center text-gray-600 font-medium hover:text-gray-900 transition-colors group"
                    >
                        Learn more about our commitment to quality
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            className="ml-2 group-hover:translate-x-1 transition-transform"
                        >
                            <path
                                d="M5 12H19M19 12L12 5M19 12L12 19"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </a>
                </div>*/}
            </div>
        </section>
    );
};

export default BrandValuesSection;